import React, { useState, useEffect } from 'react';
import '../index.scss';
import './Intro.scss';
import FadeIn from 'react-fade-in';
import splash_img from '../../assets/splash.png';
import splash from '../../assets/splash.gif';

const text = ['UI/UX Designer', 'Frontend Engineer', 'Crafting visions into interactive reality']

const Intro = () => {
    const [textVisible, setTextVisible] = useState(false);
    const [cacheBuster] = useState(Date.now());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTextVisible(true);
        }, 6000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className='sectionIntro' key={splash_img}>
            <img
                src={`${splash}?v=${cacheBuster}`}
                key={cacheBuster}
                className='intro_img'
                alt='splash_img'
            />
            <FadeIn
                visible={true}
                delay={6000}
                transitionDuration={1000}
            >
                <div className='intro_description'>
                    <FadeIn
                        visible={textVisible}
                        delay={300}
                        transitionDuration={1000}
                    >
                        {text?.map((i) => i === 'Crafting visions into interactive reality'
                            ? <span className='intro_blurb'>
                                <span></span>
                                {i}
                            </span>
                            : <h className='intro_subtitle'>
                                {i}
                            </h>
                        )}
                    </FadeIn>
                </div>
            </FadeIn>
        </div>
    )
}

export default Intro;